import React, { useContext, useEffect, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Menu, MenuProps, Select, Drawer, Button, Layout } from "antd";
import { Context } from "../../index";
import { useTranslation } from "react-i18next";
import { logo } from "../../utils/svgs";
import { items, itemsAuth } from "./routes";

export type Props = {
  language: string;
  handleLanguageChange: Function;
};

const Navbar = ({ language, handleLanguageChange }: Props) => {
  const { authStore } = useContext(Context);
  const { t } = useTranslation();
  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname);
  const history = useHistory();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setCurrent(location.pathname);
    // Определяем, какое подменю должно быть открыто
  }, [location.pathname]);

  const user =
    authStore.user?.roles?.length === 1 &&
    authStore.user.roles.includes("USER");
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const menuMobileStyle: React.CSSProperties = {
    textAlign: "left",
    backgroundColor: "#41473a",
    borderBottom: "none",
    color: "white",
  };

  const menuStyle: React.CSSProperties = {
    textAlign: "center",
    backgroundColor: "#41473a",
    borderBottom: "none",
    color: "white",
  };

  const itemsAuthSlice = user
    ? itemsAuth(t).filter((item) => item.key !== "panel")
    : itemsAuth(t);

  const onClick: MenuProps["onClick"] = (e) => {
    if (e.key === "/logout") {
      authStore.logout();
    } else {
      history.push(e.key);
    }
    setVisible(false);
  };

  return (
    <div className="header">
      <div className="logo cursor-pointer">
        <NavLink to={"/"}>{logo()}</NavLink>
      </div>

      <div className="mobileHidden">
        <Select
          defaultValue="en"
          style={{ width: 60, outline: "none", marginRight: "5px" }}
          onChange={(e) => handleLanguageChange(e)}
          options={[
            { value: "en", label: "en" },
            { value: "fr", label: "fr", disabled: true },
          ]}
          value={language}
        />
        <Menu
          style={menuStyle}
          mode="horizontal"
          selectedKeys={[current]}
          disabledOverflow
          className="menu-header"
          items={authStore.isAuth ? itemsAuthSlice : items(t)}
          onClick={onClick}
        />
      </div>
      <div className="mobileVisible">
        <Button onClick={showDrawer}>
          <i className="fas fa-bars"></i>
        </Button>
        <Drawer
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
          maskClosable={true}
        >
          <Menu
            style={menuMobileStyle}
            mode="inline"
            className="menu-header drawler-menu"
            items={authStore.isAuth ? itemsAuth(t) : items(t)}
            onClick={onClick}
            selectedKeys={[current]}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default Navbar;
